import { render, staticRenderFns } from "./iconPeople.vue?vue&type=template&id=479d70d8"
import script from "./iconPeople.vue?vue&type=script&lang=js"
export * from "./iconPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports